<template>
    <div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
//core
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
// import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
// import { AuthDeviceLoginBuilder } from '@/core/Account/model/AuthConfigModel.js';
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
export default {
    name: 'WebLogin',
    mixins: [ErrorApiMixin],
    data: function () {
        return  {
            encryptedParam: '',
            localeCode: Locale.getLocaleCode(),
            parsedData: null,
            returnUrl: '',
            locale: '',
            campaignId: null,
            jwt: null
        };
    },
    components: {
        ModalMaster
    },
    created: function () {
        Account.removeCacheUser();
        Account.removeCacheAllProfile();
        Account.removeCache('locale');
        Account.removeCacheUserDetail();
        Account.removeCache('BzbsUser');
        Account.removeCacheProfile();

        this.initialModal();
    },
    mounted: function () {
        this.encryptedParam = this.$route.query.param;
        let accessKey = this.$route.query.access;
        console.log(this.encryptedParam);
        console.log(accessKey);
        
        // this.dataMock();
        if (accessKey) {
            this.readAccessKey(accessKey);
        } else {
            this.$router.push('/error/400');
        }
    },
    methods: {
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            
            // Initialize all modals
            modalFactory.getLoadingModal();
        },
        readAccessKey: function (accessKey) { 
            this.modalController.loadingModal.show();

            BzbsAuth.apiReadAccessKey(accessKey)
                .then(res => {
                    // var data = {...res.data};
                    // var data = res.data;
                    // console.log('apiReadAccessKey response:', data);
                    // console.log(data);
                    if (res) {
                        var responseData = res.data;
                        this.locale = responseData.Locale;
                        this.campaignId = responseData.CampaignId;
                        this.returnUrl = responseData.ReturnUrl;
                        this.jwt = responseData.Jwt;
                        Account.saveCache({
                            locale: this.locale,
                            campaignId: this.campaignId,
                            returnUrl: this.returnUrl,
                            jwt: this.jwt
                        });
                        // Locale.setLocale(this.locale);
                        // Account.initial();
                        if (this.jwt && this.campaignId) {
                            this.$router.replace('/reward/detail/' + this.campaignId);
                        }
                    } else {
                        this.$router.push('/error/404');
                        return;
                    }
                    this.modalController.loadingModal.hide();
                }).catch(err => {
                    this.modalController.loadingModal.hide();
                    console.log(err);
                    this.$router.push('/error/400');
                    // this.errorApi(err, this.errorHandler);
                });
        },
        // login: function (param) {
        //     BzbsAuth.apiLoginDevice(param)
        //         .then(res => {
        //             var detail = {...res.data.detail};
        //             this.$delete(res.data, 'detail');
        //             Account.setCacheUserDetail(detail)

        //             Account.setLogin(res.data);
        //             window.location.replace('/home');
        //         }).catch(err => {
        //             console.log(err);
        //             this.errorApi(err, this.errorHandler);
        //         });
        // },
        // dataMock: function () {
        //     // Mock data for testing
        //     const mockResponse = {
        //         data: {
        //             Success: true,
        //             Data: {
        //                 ReturnUrl: "buzzebees-aia.com",
        //                 Locale: 1054,
        //                 CampaignId: 152482,
        //                 Jwt: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJBQVdfREVWUDVURVNUUFRIMjIyIiwibmJmIjoxNzY0MTMwNzkyLCJleHAiOjE3NjQyMTcxOTIsImlzcyI6Imh0dHBzOi8vYnV6emViZWVzLmNvbSIsImF1ZCI6Imh0dHBzOi8vYnV6emViZWVzLmNvbSIsImFwcCI6IjY1NjY3MDQzNTEzNjQ2NyIsInV1aWQiOiJBQVdfREVWUDVURVNUUFRIMjIyIiwicm9sZXMiOjY2LCJsZXZlbCI6MTc2MjY2MTMwMjI4NDgsInR5cGUiOiJzZXJ2ZXIiLCJsb2NhbGUiOjEwNTQsInNwb25zb3IiOjEyMDcwMCwibWFjYWRkcmVzcyI6bnVsbCwiZXh0cmEiOiJhaWEiLCJvcyI6bnVsbCwidmVyc2lvbiI6MCwiYXV0aF90b2tlbiI6bnVsbCwic2FsdCI6IjFDc2dja2lQWkpac0RVbHZJekFmdEdFc3BURTJ2aUcyLSIsImRldGFpbCI6bnVsbCwiY291bnRyeSI6IlRIIn0.czFX7Jira3lI7yoF4rSan9dXZxT2RxCdWBP8-f8lOm3tGQnpavb1DQ_tV4CDYSt7B7GMXE2370AS90mRW5rAq8HJFP--evXGv1mXy7qJSZTWT_w2aR4ePTeJek8jI96hgsRRrKPCvqG-TokxhUS-8VUlzIBCXqkAHnbWEWYfR1VFjoRrVofAlMftG6YBT37srFGQFaxn0B6ruioDdO-GYf-AuilpO5Qzc6oIOUmeCLdWQFx6jRLo6VrpY-8pf2KdcaYRoqIhElHbj50SF8aOBQFwOsAZdwhyCjjH-Cxk-GJwWB08pM_uI_iDR7tJdiOlOiQPkde_FVenWq_LpxPp3w"
        //             }
        //         }
        //     };

        //     // Use mock data instead of API call
        //     var data = {...mockResponse.data};
        //     console.log('Mock data:', data);
            
        //     if (data.Success) {
        //         var responseData = data.Data;
        //         this.locale = responseData.Locale;
        //         this.campaignId = responseData.CampaignId;
        //         this.returnUrl = responseData.ReturnUrl;
        //         this.jwt = responseData.Jwt;
                
        //         console.log('Parsed data:', {
        //             locale: this.locale,
        //             campaignId: this.campaignId,
        //             returnUrl: this.returnUrl,
        //             jwt: this.jwt
        //         });
        //         Account.saveCache({
        //             locale: this.locale,
        //             campaignId: this.campaignId,
        //             returnUrl: this.returnUrl,
        //             jwt: this.jwt
        //         });
        //         if (this.jwt && this.campaignId) {
        //             this.$router.replace('/reward/detail/' + this.campaignId);
        //         }
        //     } else {
        //         this.$router.push('/error/404');
        //         return;
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>

</style>
